import { Sparkles, Zap, Clock, TrendingUp } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const VibeCodingHeroSection = () => {
  return (
    <section className="pt-24 pb-8 sm:pt-28 sm:pb-10">
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <Badge variant="outline" className="text-primary border-primary/30 bg-primary/5">
          <Sparkles className="w-3 h-3 mr-1" />
          AI Development
        </Badge>
        <Badge variant="outline" className="text-muted-foreground border-border">
          10 min read
        </Badge>
      </div>

      <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-foreground leading-tight mb-4">
        Vibe Coding: The Future of{" "}
        <span className="text-primary">AI-Assisted Development</span>
      </h1>

      <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-3xl mb-8">
        Learn how vibe coding is revolutionizing software development. Understand prompt-driven development, 
        AI pair programming, and how to 10x your productivity with tools like Cursor, Bolt, and Claude.
      </p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Sparkles className="w-6 h-6 text-primary mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">10x</div>
          <div className="text-sm text-muted-foreground">Faster shipping</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Zap className="w-6 h-6 text-chart-2 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">70%</div>
          <div className="text-sm text-muted-foreground">Less boilerplate</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Clock className="w-6 h-6 text-chart-4 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">Minutes</div>
          <div className="text-sm text-muted-foreground">Not hours to build</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <TrendingUp className="w-6 h-6 text-chart-1 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">2025</div>
          <div className="text-sm text-muted-foreground">The year of vibe coding</div>
        </div>
      </div>
    </section>
  );
};
